import type { OrderContext } from '../types';

/**
 * Resolve OrderContext from document data and route params
 * 
 * Priority:
 * 1. Route param (e.g., /orders/b2b/:id)
 * 2. Document field (e.g., zvg_channel, channel)
 * 3. Default to 'ecommerce'
 * 
 * @param salesOrderDoc - Sales Order document data
 * @param routeParams - Optional route parameters (e.g., { channel: 'b2b' })
 * @returns Resolved OrderContext or undefined
 */
export function resolveOrderContext(
  salesOrderDoc?: Record<string, any>,
  routeParams?: { channel?: string; context?: string }
): OrderContext | undefined {
  // v1: Simple logic, can be extended later
  
  // Priority 1: Route params
  if (routeParams?.context === 'b2b' || routeParams?.channel === 'b2b') {
    return 'b2b';
  }
  
  if (routeParams?.context === 'ecommerce' || routeParams?.channel === 'ecommerce') {
    return 'ecommerce';
  }
  
  // Priority 2: Document fields
  if (salesOrderDoc) {
    const channel = salesOrderDoc.zvg_channel || salesOrderDoc.channel;
    if (channel === 'b2b') return 'b2b';
    if (channel === 'ecommerce' || channel === 'marketplace') return 'ecommerce';
  }
  
  // Priority 3: Default fallback
  return 'ecommerce';
}

